import type { LexicalNode } from "lexical";
import { DynamicContentToolbarNode } from "./dynamic-content-toolbar-node";

export function $isDynamicContentToolbarNode(
  node: LexicalNode | null | undefined,
): node is DynamicContentToolbarNode {
  return node instanceof DynamicContentToolbarNode;
}
